/* =========================================================================
   EP Nutrition – Desktop-Megamenü (Runde 30, 25.10.2026)
   Datei: assets/ep-desktop-megamenu.js
   ========================================================================= */
(function () {
  'use strict';

  /* ===== Desktop-Megamenü (Runde 30, 25.10.2026) =====
     Markup: sections/ep-desktop-megamenu.liquid, Styles: assets/ep-desktop-megamenu.css.
     Maus: Öffnen mit kurzer Verzögerung, Schließen beim Verlassen.
     Tastatur: Tab öffnet das Panel des fokussierten Punkts, Pfeil runter springt in das Panel,
     Esc schließt und setzt den Fokus zurück auf den Hauptpunkt.
     Touch/Stift: erster Tipp öffnet das Panel, zweiter Tipp folgt dem Link. Klick außerhalb schließt. */
  /* ===== Zuletzt angesehen (Menü v2, 25.10.2026) =====
     Quelle: localStorage „ep_recently_viewed“ (assets/ep-recently-viewed.js, Produktseiten):
     Array [{ title, url, price ("29,90 €"), image, vendor, ... }], neuestes zuerst.
     Erst beim ersten Öffnen eines Dropdowns: max. 3 Einträge (ohne aktuelle Seite), Bild 48×48 + Titel + Preis.
     Bilder (25.10.2026): gespeicherte Bild-URL (nur http(s), Shopify-CDN auf width=96 / 2x 192 umgeschrieben);
     <img> wird erst hier – also nach dem Öffnen – erzeugt. Ohne gültiges Bild: grauer Platzhalter.
     Fehlt Preis oder gültiges Bild, wird einmalig /products/<handle>.js nachgeladen (parallel, Fehler still).
     Gefüllt werden alle [data-epdm-recent]-Bereiche; dann wird der Bestseller-Kasten [data-epdm-best] ausgeblendet. */
  function epFormatPrice(cents, varies) {
    var n = parseInt(cents, 10);
    if (isNaN(n)) return '';
    return (varies ? 'ab ' : '') + (n / 100).toFixed(2).replace('.', ',') + ' €';
  }
  function epHandleFromUrl(url) {
    var m = /\/products\/([^\/?#]+)/.exec(url || '');
    return m ? m[1] : '';
  }
  function epReadRecent(max) {
    var items = [];
    try {
      var raw = window.localStorage.getItem('ep_recently_viewed');
      items = raw ? JSON.parse(raw) : [];
    } catch (err) { items = []; }
    if (!Array.isArray(items)) return [];
    var cur = window.location.pathname;
    return items.filter(function (it) {
      return it && typeof it.title === 'string' && it.title && typeof it.url === 'string' &&
             epHandleFromUrl(it.url) && it.url !== cur;
    }).slice(0, max);
  }
  /* Bild-URL normalisieren (String/Array/Objekt), nur http(s); Shopify-CDN auf Breite w umschreiben */
  function epImg(u, w) {
    if (Array.isArray(u)) u = u[0];
    if (u && typeof u === 'object') u = u.url || u.contentUrl || u.src || '';
    if (typeof u !== 'string') return '';
    u = u.trim();
    if (u.length < 10 || u.indexOf('/') === -1) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    if (!/^https?:\/\/[^\/]+\//.test(u)) return '';
    try {
      var x = new URL(u);
      if (/(^|\.)cdn\.shopify\.com$/.test(x.hostname) || x.pathname.indexOf('/cdn/shop/') === 0) {
        x.searchParams.set('width', String(w));
        return x.toString();
      }
      return u;
    } catch (err) { return ''; }
  }
  function epCompleteRecent(items, done) {
    var jobs = items.map(function (it) {
      it.img = epImg(it.image, 96);
      if ((it.price && it.img) || !window.fetch) return Promise.resolve(it);
      return fetch('/products/' + epHandleFromUrl(it.url) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (d && d.price != null && !it.price) it.price = epFormatPrice(d.price, d.price_varies);
          if (d && !it.img && d.featured_image) it.img = epImg(d.featured_image, 96);
          return it;
        })
        .catch(function () { return it; });
    });
    Promise.all(jobs).then(done, function () { done(items); });
  }

  function initMegaMenu() {
    var nav = document.querySelector('[data-epdm]');
    if (!nav || nav.dataset.epInit) return;
    nav.dataset.epInit = '1';
    nav.classList.add('epdm--js');

    var items = Array.prototype.slice.call(nav.querySelectorAll('.epdm-item.has-panel'));
    var pointerType = 'mouse';
    var timer = null;

    /* Banner- und Produktbilder erst beim ersten Öffnen laden (data-src/data-srcset -> src/srcset, nur einmal, nur dieses Panel) */
    function loadImages(item) {
      if (item.dataset.epdmImg) return;
      item.dataset.epdmImg = '1';
      Array.prototype.forEach.call(item.querySelectorAll('img[data-src]'), function (img) {
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
      });
    }

    /* ===== Runde 31 (26.10.2026): Panels nachladen =====
       Beim Seitenaufruf stehen nur leere Panels [data-epdm-lazy] im HTML. Einmaliger Abruf per Section Rendering API
       (nav[data-epdm-src]) beim ersten Darüberfahren/Fokus oder kurz nach dem Laden (ab 1024 px, im Leerlauf).
       Danach: aktive Links markieren, Bilder offener Panels laden, „Zuletzt angesehen“ füllen. */
    var lazySrc = nav.getAttribute('data-epdm-src');
    var panelState = (lazySrc && nav.querySelector('[data-epdm-lazy]')) ? 'todo' : 'done';
    function markActive(scope) {
      var cur = window.location.pathname.replace(/\/$/, '');
      Array.prototype.forEach.call(scope.querySelectorAll('a[href]'), function (a) {
        var p = (a.getAttribute('href') || '').split('?')[0].split('#')[0].replace(/\/$/, '');
        /* wie Shopify link.active beim Seitenaufruf: Produkt-Links werden dort nicht markiert */
        if (p && p === cur && p.indexOf('/products/') === -1 && !a.classList.contains('epdm-all')) { a.classList.add('is-active'); a.setAttribute('aria-current', 'page'); }
      });
    }
    function fillPanels() {
      if (panelState !== 'todo' || !window.fetch || !window.DOMParser) return;
      panelState = 'loading';
      fetch(lazySrc, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          var html = '';
          if (d) { for (var k in d) { if (d[k]) { html = d[k]; break; } } }
          if (!html) { panelState = 'todo'; return; }
          var doc = new DOMParser().parseFromString(html, 'text/html');
          Array.prototype.forEach.call(nav.querySelectorAll('[data-epdm-lazy]'), function (ph) {
            var src = doc.getElementById(ph.id);
            if (!src) return;
            ph.innerHTML = src.innerHTML;
            ph.removeAttribute('data-epdm-lazy');
            markActive(ph);
          });
          panelState = 'done';
          items.forEach(function (i) {
            if (i.classList.contains('is-open')) { delete i.dataset.epdmImg; loadImages(i); }
          });
          recentDone = false;
          if (nav.querySelector('.epdm-item.is-open')) loadRecent();
        })
        .catch(function () { panelState = 'todo'; });
    }
    if (panelState === 'todo') {
      nav.addEventListener('pointerenter', fillPanels);
      nav.addEventListener('focusin', fillPanels);
      var idle = function () {
        if (!window.matchMedia || !window.matchMedia('(min-width: 1024px)').matches) return;
        if (window.requestIdleCallback) window.requestIdleCallback(fillPanels, { timeout: 3000 });
        else setTimeout(fillPanels, 1500);
      };
      if (document.readyState === 'complete') idle(); else window.addEventListener('load', idle);
    }

    var recentDone = false;
    function loadRecent() {
      if (recentDone) return;
      recentDone = true;
      var items = epReadRecent(3);
      if (!items.length) return;
      epCompleteRecent(items, function (list) {
        var boxes = nav.querySelectorAll('[data-epdm-recent]');
        Array.prototype.forEach.call(boxes, function (box) {
          var ul = box.querySelector('[data-epdm-recent-list]');
          if (!ul) return;
          ul.textContent = '';
          list.forEach(function (it) {
            var li = document.createElement('li');
            var a = document.createElement('a');
            a.className = 'epdm-recent__link epdm-pi';
            a.href = it.url;
            var media = document.createElement('span');
            media.className = 'epdm-pi__media';
            if (it.img) {
              var im = document.createElement('img');
              im.className = 'epdm-pi__img';
              im.width = 48;
              im.height = 48;
              im.alt = '';
              im.decoding = 'async';
              var im2 = epImg(it.img, 192);
              if (im2 && im2 !== it.img) im.srcset = it.img + ' 1x, ' + im2 + ' 2x';
              im.src = it.img;
              media.appendChild(im);
            }
            a.appendChild(media);
            var body = document.createElement('span');
            body.className = 'epdm-pi__body';
            var t = document.createElement('span');
            t.className = 'epdm-recent__title';
            t.textContent = it.title;
            body.appendChild(t);
            if (it.price) {
              var pr = document.createElement('span');
              pr.className = 'epdm-recent__price';
              pr.textContent = it.price;
              body.appendChild(pr);
            }
            a.appendChild(body);
            li.appendChild(a);
            ul.appendChild(li);
          });
          box.hidden = false;
          var col = box.parentNode;
          var best = col && col.querySelector('[data-epdm-best]');
          if (best) best.hidden = true;
        });
      });
    }

    function setOpen(item, open) {
      if (open) { fillPanels(); loadImages(item); loadRecent(); }
      item.classList.toggle('is-open', open);
      var top = item.querySelector('.epdm-top');
      if (top) top.setAttribute('aria-expanded', open ? 'true' : 'false');
      var dim = !!nav.querySelector('.epdm-item.is-open');
      if (dim) nav.style.setProperty('--epdm-bottom', Math.max(0, Math.round(nav.getBoundingClientRect().bottom)) + 'px');
      nav.classList.toggle('epdm-dim', dim);
    }
    window.addEventListener('scroll', function () {
      if (nav.classList.contains('epdm-dim')) nav.style.setProperty('--epdm-bottom', Math.max(0, Math.round(nav.getBoundingClientRect().bottom)) + 'px');
    }, { passive: true });
    function closeAll(except) {
      items.forEach(function (i) { if (i !== except) setOpen(i, false); });
    }
    function anyOpen() {
      return !!nav.querySelector('.epdm-item.is-open');
    }

    nav.addEventListener('pointerover', function (e) {
      pointerType = e.pointerType || 'mouse';
    }, true);

    items.forEach(function (item) {
      var top = item.querySelector('.epdm-top');
      var wasOpenOnPress = false;

      item.addEventListener('mouseenter', function () {
        if (pointerType !== 'mouse') return;
        clearTimeout(timer);
        timer = setTimeout(function () {
          closeAll(item);
          setOpen(item, true);
        }, anyOpen() ? 0 : 90);
      });
      item.addEventListener('mouseleave', function () {
        if (pointerType !== 'mouse') return;
        clearTimeout(timer);
        timer = setTimeout(function () { setOpen(item, false); }, 160);
      });

      item.addEventListener('focusin', function () {
        if (item.classList.contains('is-suppressed')) return;
        if (pointerType !== 'mouse') return;
        closeAll(item);
        setOpen(item, true);
      });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) {
          item.classList.remove('is-suppressed');
          if (!item.matches(':hover')) setOpen(item, false);
        }
      });

      if (!top) return;
      top.addEventListener('pointerdown', function (e) {
        pointerType = e.pointerType || 'mouse';
        wasOpenOnPress = item.classList.contains('is-open');
      });
      top.addEventListener('click', function (e) {
        if (pointerType !== 'mouse' && !wasOpenOnPress) {
          e.preventDefault();
          closeAll(item);
          setOpen(item, true);
        }
      });
      top.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          item.classList.remove('is-suppressed');
          closeAll(item);
          setOpen(item, true);
          var first = item.querySelector('.epdm-panel a');
          if (first) first.focus();
        }
      });
    });

    /* Tastatur-Fokus (Tab) soll auch nach Mausbenutzung öffnen */
    nav.addEventListener('keydown', function (e) {
      if (e.key === 'Tab') pointerType = 'mouse';
    }, true);

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = nav.querySelector('.epdm-item.is-open');
      if (!open) return;
      setOpen(open, false);
      if (open.contains(document.activeElement)) {
        open.classList.add('is-suppressed');
        var t = open.querySelector('.epdm-top');
        if (t) t.focus();
      }
    });

    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target)) closeAll(null);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenu);
  } else {
    initMegaMenu();
  }
  document.addEventListener('shopify:section:load', initMegaMenu);
})();
